import { createFileRoute } from '@tanstack/react-router';
import { InboxAgentPage } from '@/features/inbox-agent/components/InboxAgentPage';

export const Route = createFileRoute('/_auth/inbox-agent')({
  component: InboxAgentPage,
});
